import { getNftsLogic } from "./Nfts.logic";
import { saveListNfts, saveCountNfts } from "../Infrastructure/Nfts.store";

export async function getNfts(params) {
  const { count, resources: nftsData } = await getNftsLogic(params);
  saveListNfts(nftsData);
  saveCountNfts(count);
}